import {Component} from '@angular/core';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {MatDialog, MatSnackBar, MatSnackBarConfig} from '@angular/material';
import {
	ProfileResetPasswordDialogComponent,
	ProfileResetPasswordDialogComponentInputData
} from './profile-reset-password/profile-reset-password-dialog.component';
import {UserV3Service} from '@shared/service/user-v-3.service';
import {UserV3Model} from '@shared/models/user-v-3.model';
import {PermissionService} from '@shared/service/permission.service';
import {CrossPermissionModel, UserPermissionsModel} from '@shared/models/user-permission.model';
import {EsbContractModel} from '@cc-commons/models/esb-contract.model';
import {CROSS_PERMISSION_DIGITAL_SIGNATURE} from '../../../permissions-variables';
import {CommodityModel} from '@shared/models/commodity.model';
import {MatDialogRef} from '@angular/material/dialog';
import {ChangePasswordService} from '../../services/change-password.service';
import {LoaderService} from '@shared/service/loader.service';
import {Utilities} from '@shared/utilities/utilities.model';
import {ChangePasswordParamsModel} from '../../models/change-password-params.model';
import { TranslateContext, TranslatePipe } from '@shared/pipes/translate.pipe';
import { UploadFileService } from '@app/shared/service/upload-file.service';
import { logger } from '@app/shared/utilities/logger.model';
import { AppConfigEnvironment } from '@app/shared/models/appconfig-environment.model';
import { AppConfigEnvironmentService } from '@app/shared/service/appconfig-environment.service';

@Component({
	selector: 'amd-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
	currentUser: UserV3Model;
	currentCommodities: CommodityModel[] = [];
	digital_signature_is_ir: boolean;
	translateContext: TranslateContext = TranslateContext.PROFILE;
	env: AppConfigEnvironment;
	readonly templateType = eTemplateType;
	showTemplate: boolean = false;
	userPermission: UserPermissionsModel;

	constructor(private selectCommoditiesService: SelectCommoditiesService,
				private permissionService: PermissionService,
				private userV3Service: UserV3Service,
				public changePasswordService: ChangePasswordService,
				public loaderService: LoaderService,
				protected uploadFileService: UploadFileService,
				private snackBar: MatSnackBar,
				private translatePipe: TranslatePipe,
				private appConfig: AppConfigEnvironmentService,
				public dialog: MatDialog) {

		this.env = appConfig.Environment;
		// this.showTemplate = this.userPermission.getCurrentProfile().isAdmin();		
		this.userPermission = this.permissionService.getCurrentUserPermissions();
		this.showTemplate = this.userPermission.hasSomeAdminProfile();

		this.userV3Service.getProfileData().subscribe(
			(user: UserV3Model) => {
				this.currentUser = user;
			}, error => {
				this.currentUser = this.userV3Service.getCurrentUser();
			});
		this.getCommodities();

		this.permissionService.getUserV3Permission().subscribe(
			(resp) => {
				this.digitalSignatureIsIr(resp);
			}, error => {
			});
	}

	openDialog(event: any): void {
		// this.loaderService.display(true);
		// this.changePasswordService.getChangePasswordParams().subscribe(
		// resp => {
		// 	this.loaderService.display(false);
				const dialogRef: MatDialogRef<ProfileResetPasswordDialogComponent, ProfileResetPasswordDialogComponentInputData> = this.dialog.open(ProfileResetPasswordDialogComponent, {
					height: 'auto',
					width: '730px',
					data: {
						// password_params: resp,
						username: this.currentUser.username
					}
				});
		// });
	}

	digitalSignatureIsIr(permission: UserPermissionsModel): void {
		const isIR: CrossPermissionModel[] = permission.cross_permissions.filter(isIr => isIr.key === CROSS_PERMISSION_DIGITAL_SIGNATURE);
		this.digital_signature_is_ir = isIR.length > 0;
	}

	getCommodities(): void {
		this.userPermission = this.permissionService.getCurrentUserPermissions();
		for (const profile of this.userPermission.profiles) {
			for (const commodity of profile.commodities) {
				if (commodity.ald_commodity_id !== CommodityModel.allCentersID) {
					const isPresentCommodityID: CommodityModel[] = this.currentCommodities.filter(c => c.id === commodity.id);
					if (isPresentCommodityID.length === 0) {
						this.currentCommodities.push(commodity);
					}
				}
			}
		}
	}

	/**
	 * Download del template di creazione o rimozione
	 * gestito dal BE
	 * 
	 * @param key tipo template
	 */
	downloadTemplate(type: eTemplateType): void {

		const {uuid, file_name} = { ...this.env.administration_template[type] };

		this.uploadFileService.downloadAttachedFile(uuid).subscribe(
			response => {				
				if (Utilities.isEmpty(response)) {
					logger.error('DownloadListComponent ', 'downloadFile ', response);
					this.showDownloadFileErrorMessage();
					return;
				}
				
				Utilities.downloadFile(response, file_name);
			}, () => {
				this.showDownloadFileErrorMessage();
			}
		);
	}
	
	showDownloadFileErrorMessage(): void {
		const config: MatSnackBarConfig = new MatSnackBarConfig();
		config.duration = 2000;
		config.panelClass = ['snack-bar-error'];
		this.snackBar.open(this.translatePipe.transform('IMPOSSIBILE_SCARICARE_L_ALLEGATO', TranslateContext.SHARED), '', config);
	}
}

enum eTemplateType {
	CREAZIONE = 'create_modify',
	RIMOZIONE = 'remove',
}